var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.channels),function(channel){return [_c('v-btn',{key:("channel_" + channel),staticClass:"ma-0 mr-1 mb-1",attrs:{"depressed":"","outline":_vm.value != channel,"color":_vm.value == channel ? 'primary' : 'grey'},on:{"click":function($event){return _vm.onchange(channel)}}},[_vm._v(_vm._s(_vm.$t(channel)))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cfbde1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/dashboard/SelectChannel.vue
// module id = null
// module chunks = 